<template>
  <a-modal
    :title="formTitle"
    v-model:visible="open"
    :width="720"
    :maskClosable="false"
    :destroyOnClose="true"
    :footer="null"
    @cancel="cancel"
  >
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 120px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
    >
      <a-form-item label="空间" name="spaceId">
        <a-select
          v-model:value="form.spaceId"
          show-search
          allow-clear
          placeholder="请选择空间"
          :filter-option="filterOption"
          @change="onSpaceChange"
        >
          <a-select-option v-for="item in spaceOptions" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="覆盖信标" name="beaconId">
        <a-select
          v-model:value="form.beaconId"
          show-search
          allow-clear
          placeholder="一标多空间时必选同一信标"
          :filter-option="filterOption"
          @change="onBeaconChange"
        >
          <a-select-option v-for="item in beaconOptions" :key="item.id" :value="item.id">
            {{ item.mac }}{{ item.spaceName ? '（主空间:' + item.spaceName + '）' : '' }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="责任员工" name="userId">
        <a-select
          v-model:value="form.userId"
          show-search
          allow-clear
          placeholder="请选择责任员工"
          :filter-option="filterOption"
          @change="onUserChange"
        >
          <a-select-option v-for="item in userOptions" :key="item.userId || item.id" :value="item.userId || item.id">
            {{ item.nickName || item.userName || item.nickname }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="备注" name="remark">
        <a-input v-model:value="form.remark" placeholder="可选" allow-clear />
      </a-form-item>

      <div style="text-align: right">
        <a-button @click="cancel" style="margin-right: 8px">取消</a-button>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $emit } from '../../../../utils/gogocodeTransfer'
import { getSpaceDutyUser, addSpaceDutyUser, updateSpaceDutyUser } from '@/api/system/spaceDutyUser'
import { listSpace } from '@/api/system/space'
import { listBeacon } from '@/api/system/beacon'
import { listProjectUserOptions } from '@/api/system/user'

export default {
  name: 'SpaceDutyUserCreateForm',
  data() {
    return {
      open: false,
      formTitle: '新增空间值班人员',
      submitLoading: false,
      spaceOptions: [],
      beaconOptions: [],
      userOptions: [],
      form: {
        id: null,
        projectId: null,
        spaceId: null,
        spaceName: null,
        beaconId: null,
        beaconMac: null,
        userId: null,
        userName: null,
        remark: null,
      },
      rules: {
        spaceId: [{ required: true, message: '请选择空间', trigger: 'change' }],
        userId: [{ required: true, message: '请选择责任员工', trigger: 'change' }],
      },
    }
  },
  methods: {
    reset() {
      this.form = {
        id: null,
        projectId: this.$store.getters.currentProjectId,
        spaceId: null,
        spaceName: null,
        beaconId: null,
        beaconMac: null,
        userId: null,
        userName: null,
        remark: null,
      }
    },
    loadOptions() {
      const projectId = this.$store.getters.currentProjectId
      if (!projectId) return
      listSpace({ projectId }).then((res) => {
        this.spaceOptions = (res && res.data) || []
      })
      listBeacon({ projectId }).then((res) => {
        this.beaconOptions = (res && res.data) || []
      })
      listProjectUserOptions({ projectId }).then((res) => {
        this.userOptions = (res && res.data) || []
      })
    },
    handleAdd() {
      this.reset()
      this.formTitle = '新增空间值班人员'
      this.loadOptions()
      this.open = true
    },
    handleUpdate(row) {
      this.reset()
      this.formTitle = '编辑空间值班人员'
      this.loadOptions()
      getSpaceDutyUser({ id: row.id }).then((res) => {
        this.form = Object.assign({}, this.form, res.data || {})
        this.open = true
      })
    },
    onSpaceChange(val) {
      const space = this.spaceOptions.find((s) => s.id === val)
      this.form.spaceName = space ? space.name : null
    },
    onBeaconChange(val) {
      const beacon = this.beaconOptions.find((b) => b.id === val)
      this.form.beaconMac = beacon ? beacon.mac : null
    },
    onUserChange(val) {
      const user = this.userOptions.find((u) => (u.userId || u.id) === val)
      this.form.userName = user
        ? user.nickName || user.userName || user.nickname || ''
        : null
    },
    filterOption(input, option) {
      const text = option && option.children ? String(option.children).toLowerCase() : ''
      return text.indexOf((input || '').toLowerCase()) >= 0
    },
    cancel() {
      this.open = false
      this.reset()
    },
    submitForm() {
      this.$refs.form.validate().then(() => {
        this.submitLoading = true
        this.form.projectId = this.$store.getters.currentProjectId
        const req = this.form.id ? updateSpaceDutyUser(this.form) : addSpaceDutyUser(this.form)
        req
          .then(() => {
            this.$message.success('保存成功')
            this.open = false
            $emit(this, 'ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
  },
  emits: ['ok'],
}
</script>
